import { LazyCodeEditorCompatWrapper, type LegacyCodeEditorProps } from './LazyCodeEditorCompatWrapper';

export type MigratedLazyCodeEditorProps = LegacyCodeEditorProps;

export const MigratedLazyCodeEditor = (props: LegacyCodeEditorProps) => <LazyCodeEditorCompatWrapper {...props} />;
